<template lang="pug">
  #card
    v-container(fluid grid-list-xs)
      v-layout(row, wrap)
        v-card.postcard(:id="report.folio")
          v-layout(fluid, row, wrap @click="highlight(report.folio)")
            v-flex(xs3)
              v-card-text.data.folio.pb-0
                | #
                | {{report.contextId ? report.contextId + "-" : '' }}{{report.folio}}
              v-card-text.data.pt-1.pb-2 {{report.date}}
              v-card-actions.d-flex.pb-1.action
                v-btn.view(flat justify-center @click="view(report.folio)") VER POSTAL
              v-card-actions.d-flex.pt-1
                v-btn.view.map(flat justify-center v-scroll-to="'#mapid'") VER EN MAPA
            v-flex(xs9)
              v-card-title(primary-title)
                div.title
                  h3.headline.mb-0 {{report.state}} /&nbsp;
                    span.mun {{report.municipality}}
                  span.type  {{report.type}}
              v-card-text.description {{report.facts}}
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Card",
  props: {
    report: Object,
  },
  computed: {
    ...mapGetters({
      getSelection: "selected",
    }),
  },
  methods: {
    highlight(folio) {
      const lastSelection = this.getSelection;
      if (lastSelection === folio)
        this.$store.commit("setSelection", undefined);
      else this.$store.commit("setSelection", folio);

      const allCards = window.document.getElementsByClassName("postcard");
      const cards = Array.prototype.slice.call(allCards);
      cards.forEach((card) => {
        if (card.id != folio || folio === lastSelection) {
          card.classList.remove("selected");
        } else {
          card.classList.add("selected");
        }
      });
    },
    view(folio) {
      window.open(
        "https://s3.amazonaws.com/images.rompeelmiedo.org/" + folio + ".png",
        "_blank"
      );
    },
  },
  watch: {
    getSelection: function () {
      const allCards = window.document.getElementsByClassName("postcard");
      const cards = Array.prototype.slice.call(allCards);
      cards.forEach((card) => {
        if (card.id != this.getSelection) {
          card.classList.remove("selected");
        } else {
          card.classList.add("selected");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../app.scss";
.selected {
  border: 5px solid #9b9b9b !important;
}
.postcard {
  background-color: $light-background !important;
  border-top: 1px solid #c3c6c7;
  border-bottom: 1px solid #888c8d;
  border-left: 1px solid #939899;
  margin: 0.6rem;
  font-family: "Rajdhani", sans-serif;
  .data {
    color: $light-text;
    font-weight: 600;
    font-size: 1.3rem;
    &.folio {
      font-size: 1.5rem !important;
    }
  }
  .view {
    border: 1.5px solid $medium-text;
    border-radius: 5px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2) !important;
    color: $medium-text !important;
    max-width: 80%;
    font-size: 1rem;
    font-weight: 700;
    padding-top: 0;
    line-height: 1.1;
    white-space: normal !important;
  }
  .title {
    color: $dark-title;
    h3 {
      font-family: "Barlow Semi Condensed", sans-serif !important;
      font-weight: 600;
      .mun {
        font-weight: 500;
      }
    }
    .type {
      font-size: 16px !important;
      font-weight: 500 !important;
    }
  }
  .description {
    color: $dark-text;
    padding-top: 0;
    font-size: 1.1rem;
    font-weight: 500;
  }
}

@media (max-width: 576px) {
  .data,
  .card__actions {
    padding-left: 0.5rem;
    text-align: center;
  }
  .postcard .map {
    display: none !important;
  }
}

/*#card {
    background-color: #f8f8f8;
    font-family: 'Rajdhani', sans-serif;
    .folio, .date {
      p {
        color: rgba(139, 139, 139, 0.87);
        font-size: 19px;
        font-weight: 600;
      }
    }
    .postcard, .map {
      p {
        color: #747474;
        border: solid 1px #747474;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .place {
      p {
        color: #212034;
        font-family: 'Barlow', sans-serif;
        font-size: 21px;
        font-weight: 400;
        span {
          font-weight: 600;
        }
      }
    }
    .type {
      p {
        color: #212034;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .details {
      p {
        color: #4a4a4a;
        font-size: 15px;
        font-weight: 500;
      }
    }
  }*/
</style>
